import { Link } from '@/components/Link';
import { useStable, useStableOptions } from '@/hooks/useStable';
import useUserAuth from '@/hooks/useUserAuth';
import { mergeProps } from '@/utils/merge';
import { StandaloneContentLock } from 'base/components/ContentLock';
import { useMemo } from 'react';

export const ElleStandaloneContentLock: typeof StandaloneContentLock = (props) => {
  const { signUpUrl } = useUserAuth();

  const footer = useMemo(
    () => (
      <Link
        options={{ className: 'cts-impression-item', rel: 'nofollow' }}
        data-cts-label="content_lock"
        data-cts-id="login_locked_article_signup_link"
        data-cts-name="login_locked_article_signup_link"
        data-cts-creative="content_lock"
        href={signUpUrl}
        content="Eller skapa ditt konto gratis idag"
      />
    ),
    [signUpUrl],
  );

  const headline = useMemo(
    () => (
      <>
        Vill du läsa hela artikeln?
        <br />
        Skapa ett konto på ELLE - helt gratis!
      </>
    ),
    [],
  );

  const content = useStable({
    login: {
      caption: 'Medlemmar får mer - erbjudanden, event och obegränsad läsning.',
      footer,
      headline,
    },
  });

  const options = useStableOptions({
    $login: {
      className: 'cts-impression-group',
      $button: {
        className: 'cts-impression-item',
        'data-cts-label': 'content_lock',
        'data-cts-id': 'login_locked_article_login_button',
        'data-cts-name': 'login_locked_article_login_button',
        'data-cts-creative': 'content_lock',
      },
    },
  });

  return <StandaloneContentLock {...mergeProps({ content, options }, props)} />;
};
